import { FormEvent, useEffect, useState } from "react";
import Button from "../../shared/components/UI/Button";
import MarginBox from "../../shared/components/other/MarginBox";
import Navbar from "../../shared/components/navbar/NavBar";
import MultiSelect from "../../shared/components/UI/MultiSelect";
import Footer from "../../shared/components/Footer/Footer";
import "./calendar.scss";
import CalendarComponent from "./components/CalendarComponent";
import GameCard from "./components/GameCard";
import GameCardSkeleton from "./components/GameCardSkeleton";
import useEventCards from "../../shared/hooks/useEventCards";
import { useSearchParams, useParams } from "react-router";
import {
  convertToEventsDTO,
  convertToEventsForm,
  EventsDTO,
  EventsForm,
  convertUrlParamsToEventsDTO,
  SortingType
} from "./types/CalendarTypes";
import { useForm } from "react-hook-form";
import useEventFilterTypes from "./hooks/useFilters";
import { displayNotImplemented } from "../../shared/services/Notifications/NotificationServices";
import { convertDTOToUrlParams } from "../../shared/shared";
import ScrollUpButton from "../../shared/components/ScrollUpButton/ScrollUpButton";

// Убрать баг с мерцанием календаря при наведении на кнопки

// ФИльтры с чекбоксами регистрируем через register
// Если быстрый фильтр повторяез значение из select - То вручную менять фильтр который в селекуте а не подписывать чекбоксы на всякое
// Понять разницу между control и useField
//дсонединить х с кнопкой
//Не забудь про запрос на увеличение выборки
//Исправить таймзону календаря
//\настроить календарь на даты назад
// конечная дата - включительно (исправлено костылем)
// добавить поиск (согласовать с бэком)
// добавить филтрацию (солгласовать с бэком)

//согласовать поведение селекта если чебкосы выбраны, но нужно его закрыть

export default function Calendar() {
  const [isOpenModal, setIsOpenModal] = useState(false)

  const [searchParams, setSearchParams] = useSearchParams();

  const {data: filterTypes, isLoadingF, errorF} = useEventFilterTypes();

  const limit = 16;

  const { handleSubmit, control, getValues, setValue, watch, register, reset } =
    useForm<EventsForm>({
      defaultValues: (() => {
        const params = new URLSearchParams(searchParams);
        return convertUrlParamsToEventsDTO(params);
      })()
    });

  const formData = watch();

  const [startDate, endDate] = watch(["date_from", "date_to"]);

  const [activeFilters, setActiveFilters] = useState<EventsForm>(() => {
    const params = new URLSearchParams(searchParams);
    return convertUrlParamsToEventsDTO(params);
  });

  // блок дефолт фильтра, принудительно обновляет url при первом заходе
  useEffect(() => {
     if (filterTypes?.states && !searchParams.has('state')) {
      const newParams = new URLSearchParams(searchParams.toString());
      filterTypes.states
        .filter((state: any) => 
          state.id !== "completed" && 
          state.id !== "cancelled"
        )
        .forEach((state: any) => newParams.append('state', state.id));
        setSearchParams(newParams, { replace: true });
    }
  }, [filterTypes?.states, searchParams, setSearchParams]);
// при изменении url
  useEffect(() => {
    setActiveFilters(convertUrlParamsToEventsDTO(searchParams));
  }, [searchParams]);

  let {
    cardsData,
    isFetched,
    isLoading,
    error,
    refetch,
    cardsCount,
    fetchNextPage,
    hasNextPage,
  } = useEventCards(activeFilters);

  // Автоматическая отправка при выборе обеих дат
  useEffect(() => {
    if ((startDate && endDate) || !(startDate || endDate)) {
      handleSubmit(onSubmit)();
    }
  }, [startDate, endDate, handleSubmit]);

  const cardElements = cardsData?.map((card: any, index: any) => {
    return (
      <GameCard
        key={index}
        openState={card.state}
        peopleCount={card.count_participants_total || "0"}
        name={card.name}
        dateTime={card.start_datetime}
        address={card.ground?.address}
        imgSrc={card.images}
        tags={card.tags?.map((el: any) => el.name)}
        slug={card.slug}
      />
    );
  });

  const onSubmit = (form: EventsForm) => {
    setActiveFilters(form);
    const params: any = convertDTOToUrlParams(convertToEventsDTO(form));
    setSearchParams(params);
  };

  const handleReset = () => {
    setSearchParams({});
    reset({});
    setActiveFilters({});

  };

  const handleShowMore = () => {
    fetchNextPage();
  };

  const cardsLeft = Math.max(cardsCount - (cardsData?.length || 0), 0);

  const cardsToShow = Math.min(limit, cardsLeft);

  const showMoreButton = hasNextPage && (
    <Button darkStyle className="calendar-moreButton" onClick={handleShowMore}>
      Показать ещё {cardsToShow} из {cardsLeft}
    </Button>
  );

  const handleClickMySorting = () => {
    const newActiveState = !!!getValues('my')

    setValue("my", newActiveState);

    handleSubmit(onSubmit)();
  }

  const isMy = watch('my') ? 'active' : ''

  useEffect(() => {
    const fValues = convertUrlParamsToEventsDTO(searchParams)
    reset(fValues)
    setActiveFilters(fValues)
  }, [searchParams, reset])

  return (
    <MarginBox>
      <header>
        <Navbar />
      </header>
      <main className="main">
        {/* <Button onClick={() => {
                    setArrSt((last) => {
                        return 'не а';
                    })
                }}></Button> */}
        <h1>События в Санкт-Петербурге</h1>
        <form className="calendar-filters" onSubmit={handleSubmit(onSubmit)}>
          <CalendarComponent
            startDateName="date_from"
            endDateName="date_to"
            getValues={getValues}
            setValue={setValue}
          />
          <div className="calendar-filters-container">
            <div className="calendar-filters-flex">
              <Button
                darkStyle
                onClick={displayNotImplemented}
                className="calendar-filters-input calendar-filters-input-iconed"
              >
                <img
                  src="/calendar/searchIcon.svg"
                  alt="Искать"
                  className="calendar-filters-icon"
                />
              </Button>
              {/* Должно быть чекбоксом */}
              <Button
                darkStyle
                onClick={displayNotImplemented}
                className="calendar-filters-input  calendar-filters-input-iconed"
              >
                <img
                  src="/calendar/filterIcon.svg"
                  alt="Фильтровать"
                  className="calendar-filters-icon"
                />
              </Button>
              <Button
                className={`calendar-filters-input  calendar-filters-input-iconed ${isMy}`}
                onClick={handleClickMySorting}
              >
                Мои мероприятия
              </Button>
              {/* <Button className='calendar-filters-input'>Все</Button>
                            <Button className='calendar-filters-input'>Выставки</Button>
                            <Button className='calendar-filters-input'>Игры</Button> */}
              {/* <Select className='calendar-filters-input' title='Вид мероприятия'></Select>
                            <Select className='calendar-filters-input' title='Тип мероприятия'></Select> */}
              <MultiSelect
                className="calendar-filters-input"
                classes={{
                  multiSelect_menu_wrapper: 'calendar-filters-multiselect-menu type'
                }}
                hasSearch={true}
                title="Тип мероприятия"
                name="type"
                items={filterTypes?.types}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              <MultiSelect
                className="calendar-filters-input"
                classes={{
                  multiSelect_menu_wrapper: 'calendar-filters-multiselect-menu subtype'
                }}
                hasSearch={true}
                title="Подтип"
                name="subtype"
                items={filterTypes?.subtypes}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              <MultiSelect
                className="calendar-filters-input"
                classes={{
                  multiSelect_menu_wrapper: 'calendar-filters-multiselect-menu status'
                }}
                hasSearch={true}
                title="Статус"
                name="state"
                items={filterTypes?.states}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              <MultiSelect
                className="calendar-filters-input"
                classes={{
                  multiSelect_menu_wrapper: 'calendar-filters-multiselect-menu registration'
                }}
                hasSearch={true}
                title="Регистрация"
                name="reg_type"
                items={filterTypes?.reg_types}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              <MultiSelect
                className="calendar-filters-input"
                classes={{
                  multiSelect_menu_wrapper: 'calendar-filters-multiselect-menu grounds'
                }}
                hasSearch={true}
                title="Полигоны"
                name="ground"
                items={filterTypes?.grounds}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>
              <MultiSelect
                className="calendar-filters-input"
                classes={{
                  multiSelect_menu_wrapper: 'calendar-filters-multiselect-menu organizers'
                }}
                hasSearch={true}
                title="Организаторы"
                name="event_host"
                items={filterTypes?.event_hosts}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
              ></MultiSelect>

              {/* <div className='defaultInput calendar-filters-input'><Button refStyle><img className='calendar-filters-dateReset-icon' src="/UI/closeIcon.svg" alt="Сбросить" /></Button>9-16 ноября</div> */}
              <Button
                className="calendar-filters-input calendar-filters-resetButton"
                darkStyle
                onClick={handleReset}
              >
                <img
                  className="calendar-filters-reset-icon"
                  src="/UI/closeIcon.svg"
                  alt="Сбросить"
                />
              </Button>
            </div>
            <div className="calendar-filters-region">
              <img src="/calendar/placeIcon.svg" alt="" />
              <a className="calendar-filters-region-text" href="#root">
                Санкт-Петербург
              </a>
            </div>
          </div>
          {/* <SelectMenu title='Город'/> */}
          {/* <SelectMenu title='Город'/> */}
        </form>
        <div className="calendar-cards">
          <div className="calendar-cards-wrapper">
            {isLoading ? (
              Array(limit).fill(null).map((_, index) => (
                <GameCardSkeleton key={index} />
              ))
            ) : (
              cardElements
            )}
          </div>
        </div>
        {showMoreButton}
      </main>
      <Footer />
      <ScrollUpButton />
    </MarginBox>
  );
}
